// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__ICcgD","tab":"Tabs_tab__3C7BK","tabActive":"Tabs_tabActive__neVWr"};